import axios from "axios";
import APILinks from "../links/links";

export default {
    requireToken(formData) {
        const headers = {
            "Content-Type": "application/json"
        };        
        return axios.post(APILinks.REQ_TOKEN, JSON.stringify(formData), {
            headers: headers
        });
    },
    register(formData) {
        const headers = {
            "Content-Type": "application/json"
        };        
        // const bodyFormData = new FormData();
        // bodyFormData.append('username', formData.username);
        // bodyFormData.append('password', formData.password);
        // bodyFormData.append('email', formData.email);
        // console.log("bodyFormData:",bodyFormData);
        return axios.post(APILinks.REGISTER, formData, {
            headers: headers
        });
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/login/authApi.js